import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";
import { getColor } from "../../brandConfig";
const PokerCoach = React.lazy(() => import("./PokerCoach"));
const ResultsDashboard = React.lazy(() => import("./ResultsDashboard"));
const StrategyGuide = React.lazy(() => import("./StrategyGuide"));
const NodeEarnings = React.lazy(() => import("./NodeEarnings"));
const InvestorDeck = React.lazy(() => import("./InvestorDeck"));
const config: ModuleConfig = {
  id: "poker-coach",
  name: "Poker Coach",
  description:
    "Position coaching, public Block52 table updates and replay practice.",
  version: "0.4.0",
  enabled: true,
  category: "communication",
  order: 13,
  icon: "🃏",
  color: getColor("primary"),
  permissions: { view: [], create: [], edit: [], delete: [] },
  navigation: [
    { label: "Investor deck", path: "/poker-coach/node/deck", icon: "📽️", permissionLevel: "view" },
    { label: "Node earnings & ROI", path: "/poker-coach/node", icon: "🖥️", permissionLevel: "view" },
    { label: "Poker Coach", path: "/poker-coach", icon: "🃏", permissionLevel: "view" },
    { label: "Position & strategy", path: "/poker-coach/strategy", icon: "📖", permissionLevel: "view" },
    { label: "Results & money", path: "/poker-coach/results", icon: "📊", permissionLevel: "view" },
  ],
  routes: [
    { path: "/poker-coach/node/deck", component: InvestorDeck, permissionLevel: "view", useLayout: false },
    { path: "/poker-coach/node", component: NodeEarnings, permissionLevel: "view", useLayout: true },
    { path: "/poker-coach/results", component: ResultsDashboard, permissionLevel: "view", useLayout: true },
    {
      path: "/poker-coach",
      component: PokerCoach,
      permissionLevel: "view",
      useLayout: true,
    },
    {
      path: "/poker-coach/strategy",
      component: StrategyGuide,
      permissionLevel: "view",
      useLayout: true,
    },
  ],
};
export default config;
